export default theme => ({
  paddingBottom: {
    paddingBottom: 10,
  },
  equipmentBlock: {
    display: 'flex',
    alignItems: 'center',
    width: 'max-content',
    maxWidth: '100%',
    height: 24,
    fontSize: 14,
    fontWeight: 500,
    fontFamily: 'Poppins',
  },
  equipmentNumber: {
    color: theme.palette.textColor.white,
    padding: '3px 6px',
    borderRadius: 20,
    textAlign: 'center',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
  },
  equipmentName: {
    marginLeft: 4,
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    width: 'max-content',
  },
  inlineFlex: {
    display: 'inline-flex',
    alignItems: 'center'
  },
  flex: {
    display: 'flex',
    flexDirection: 'column',
    gap: 2,
  },
  hoursBlock: {
    height: '100%',
    width: '100%',
    justifyContent: 'flex-end',
  },
  clickable: {
    cursor: 'pointer',
  },
  resourceHoursValues: {
    paddingLeft: '2px !important',
    '&:first-child': {
      paddingTop: '4px',
    }
  }
});
